import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ItemTableFilterSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/item-ledger/_list/')({
  validateSearch: zodValidator(ItemTableFilterSchema)
});